




























import {
  computed,
  defineComponent,
  getCurrentInstance,
  ref,
  PropType,
} from '@vue/composition-api'

import ExportButton from '@/components/molecules/h/ExportButton.vue'
import ExtractCondition from '@/components/organisms/h/page/order-budget/order-budget-create/ExtractCondition.vue'
import OutputCondition from '@/components/organisms/h/page/order-budget/order-budget-create/OutputCondition.vue'
import TitleAndManipulate from '@/components/organisms/h/TitleAndManipulate.vue'
import {
  outputCondUseInfoList,
  OrderBudgetCreateExtractCondition,
  OrderBudgetCreateOutputCondition,
} from '@/types/entities'
export default defineComponent({
  components: {
    TitleAndManipulate,
    ExtractCondition,
    OutputCondition,
    ExportButton,
  },
  props: {
    outputUseList: {
      type: Array as PropType<outputCondUseInfoList>,
      default: () => [],
    },
    isDisable: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    totalCount: {
      type: String as PropType<string>,
      default: null,
    },
    exportSpinner: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    exportErrorMessage: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup(_, context) {
    const instance = getCurrentInstance()
    if (!instance) {
      // should be called in setup
      return
    }
    const { $i18n } = instance.proxy

    const requestExport = () => {
      context.emit('request-export')
    }
    const changeExtractCondition = (cond: OrderBudgetCreateExtractCondition) => {
      context.emit('change-extract-condition', cond)
    }

    const changeOutputCondition = (
      cond: OrderBudgetCreateOutputCondition) => {
      context.emit('change-output-condition', cond)
    }

    return {
      requestExport,
      changeExtractCondition,
      changeOutputCondition,
    }
  },
})
